import React from 'react';
import Module from './Module';

const SectionHeader = (props) => {
	const icon = props?.icon ?? false;
	const title = props?.title ?? "[ Section ]";
	const title_tooltip = props?.title_tooltip ?? false;
	const subtitle = props?.subtitle ?? false;
	const extra = props?.extra ?? false;
	const padded_extra = props?.padded_extra ?? false;
	const extra_component = props?.extra_component ?? false;
	const total = props?.total ?? false;
	
	const filters = props?.filters ?? false;
	
	let header_class = ['gui_power_header', 'main_bg', 'shadow_small'];

	return (
		<Module type='header' _class={{ other:header_class.join(" ") }}>
			<div class="is_header">
				<div class="gui_flexbox_auto gui_flex_row gui_flex_nowrap">
					<div class="is_info">
						<h1 class={`title ${(icon?.icon ?? '')}`}>
							{title}

							{(title_tooltip !== false) && (
								title_tooltip
							)}
						</h1>

						{(subtitle !== false) && (
							<div class="subtitle">{subtitle}</div>
						)}

						{(total !== false) && (
							<h5 class="total">{total}</h5>
						)}

						{(extra !== false) && (
							<div class={`extra${(padded_extra) ? ' padded_extra' : ''}`}>
								{extra}
							</div>
						)}
					</div>
				</div>

				{(props?.children != undefined) && (
					props.children
				)}
			</div>

			{(filters !== false) && (
				<div class="is_filter">
					{filters}
				</div>
			)}

			{(extra_component !== false) && (
				<div class="is_filter">
					{extra_component}
				</div>
			)}
		</Module>
	)
};

export default SectionHeader;